import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { CartModel } from 'src/app/models/cart.model';
import { OrderDatesModel } from 'src/app/models/order-dates.model';
import {
  MenuCategory,
  MenuItem,
  MenuItemCatalog,
  MenuItemCatalogPrice,
  MenuSection,
} from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { ScheduledCartService } from 'src/app/services/scheduled-cart.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { ToastMachineService } from 'src/app/services/toast-machine.service';

@Component({
  selector: 'app-scheduled-cart',
  templateUrl: './scheduled-cart.component.html',
  styleUrls: ['./scheduled-cart.component.scss'],
})
export class ScheduledCartComponent implements OnInit {
  @Input() menuItem: MenuItem;
  @Input() menuSection: MenuSection;
  @Input() menuCategory: MenuCategory;

  orderDates: OrderDatesModel[];
  timeOfOrder: string;
  capacityName: string;
  phoneNumber: string;
  name: string;
  selectedDate: OrderDatesModel;
  catalog: MenuItemCatalog;
  processing = false;
  size: MenuItemCatalogPrice;

  constructor(
    private mdlctrl: ModalController,
    public authServ: AuthService,
    public dataServ: DataService,
    public cartServ: CartService,
    private analytics: AnalyticsService,
    private caption: CaptionPipe,
    public alertCtrl: AlertController,
    private scheduledCartServ: ScheduledCartService,
    private changeDetector: ChangeDetectorRef,
    private analyticsServ: AnalyticsService,
    private modalServ: ModalMakerService,
    private toaster: ToastMachineService
  ) {}

  async ngOnInit() {
    this.orderDates = await this.scheduledCartServ.getOrderDates(
      this.menuItem.id
    );
    this.selectedDate = this.orderDates.find(
      (orderDate) => orderDate.times?.length > 0
    );
  }

  ionViewDidEnter() {
    document.querySelectorAll('ion-button').forEach((btn) => {
      btn.addEventListener('click', (event: Event) => {
        this.analytics.eventEmitter(
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_click`,
          'button',
          'click',
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_click`,
          this.dataServ.menuItem.id
        );
      });
    });

    if (sessionStorage.getItem('tableNo')) {
      this.capacityName = sessionStorage.getItem('tableNo');
    }
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  findCatalogById(cartItem: CartModel) {
    return cartItem.item.menu_item_catalog_groups
      .find(
        (catalogGroup) =>
          catalogGroup.id === cartItem.size.menu_item_catalog_group_id
      )
      .menu_item_catalogs.find(
        (catalog) => catalog.id === cartItem.size.menu_item_catalog_id
      );
  }

  getSizeById(cartItem: CartModel) {
    return cartItem.item.menu_item_catalog_groups
      .find(
        (catalogGroup) =>
          catalogGroup.id === cartItem.size.menu_item_catalog_group_id
      )
      .menu_item_catalogs.find(
        (catalog) => catalog.id === cartItem.size.menu_item_catalog_id
      )
      .menu_item_catalog_prices.find((price) => price.id === cartItem.size.id);
  }

  cartUpdate(catalogItem: MenuItemCatalog, size: MenuItemCatalogPrice) {
    this.processing = true;
    this.changeDetector.detectChanges();
    const EXIST = this.cartServ.cart.findIndex((x) => x.size.id === size.id);

    if (EXIST >= 0) {
      this.cartServ.cart[EXIST].size = size;
    } else {
      this.cartServ.cart.push({
        item: this.dataServ.menuItem,
        product: catalogItem,
        size,
        note: '',
        basePrice: size.activate_offer
          ? size.offer_price
          : this.dataServ.rData.general_discount_percentage
          ? size.price -
            (size.price * this.dataServ.rData.general_discount_percentage) / 100
          : size.price,
      });
    }

    this.cartServ.calcTotal();
    this.processing = false;
    this.changeDetector.detectChanges();
  }

  analytic(
    catalogItem: MenuItemCatalog,
    size: MenuItemCatalogPrice,
    type: 'add' | 'remove'
  ) {
    this.analyticsServ.eventEmitter(
      `${this.caption.transform(
        catalogItem.name,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${this.caption.transform(
        size.size,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${type}_cart`,
      'cart',
      'click',
      `${this.caption.transform(
        catalogItem.name,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${this.caption.transform(
        size.size,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${type}_cart`
    );
  }

  next() {
    this.processing = true;
    this.modalServ.note(this.timeOfOrder, this.selectedDate.date);
    this.processing = false;
  }

  showToaster() {
    let msg = '';
    if (!this.timeOfOrder) {
      msg = 'Please select delivery time.';
    }
    if (this.timeOfOrder && this.cartServ.totalAmount === 0) {
      msg = 'Total amount is zero.';
    }
    this.toaster.toastMachine(msg, 'danger', 3000);
  }

  getTotalAmount(totalAmount): number {
    let newTotalAmount: number;
    if (totalAmount > this.menuItem.free_delivery_over_amount) {
      newTotalAmount = totalAmount;
    } else {
      newTotalAmount = totalAmount + this.menuItem.service_charge;
    }

    return newTotalAmount;
  }
}
